<template>
  <span>
    <modal>
      <template v-slot:header>
        <h3 class="modal-title">
          {{ getTitleTransferNotes() }}
        </h3>
          <button @click="onClose()" type="button" class="btn-close"></button>
      </template>
      <template v-slot:body>
        <div class="text-end">
            <button v-if="isAuthorized('administration', 'transfer-notes', 'add')"
                @click="startNewTransferNote()"
                class="btn btn-success"
            >
              Nieuw
            </button>
        </div>
        <br>
        <transfer-notes-list
          :notes="filteredTransferNotes"
          :filterBy="getTitleTransferNotes().toLowerCase()"
          :openDialog="addNewTransferNote"
          @dialogAddTransferNoteShow="onDialogAddShow"
        />
      </template>
      <template v-slot:footer>
        <div>
          <button
              type="button"
              class="btn btn-outline-info"
              @click="onClose()"
          >
            Sluiten
          </button>
        </div>
      </template>
    </modal>
  </span>
</template>

<script>
import Modal from '@/components/Modal'
import TransferNotesList from '@/components/Transfer-Notes-List'
export default {
  name: 'transfer-notes-overview-modal',
  components: {
    Modal,
    TransferNotesList
  },
  props: {
    date: {
      type: String,
      required: true
    },
    transferNotesType: {
      type: String,
      required: true
    }
  },
  computed: {
    transferNotes () {
      let transferNotes = this.$store.getters.transferNotes
      transferNotes = transferNotes.sort((a,b) => {
        if (a.date < b.date) {
          return 1;
        } else if (a.date > b.date) {
          return -1;
        } else if (a.date === b.date) {
          if (a.id > b.id) {
            return -1;
          } else {
            return 1;
          }
        }
        return 0;
      })
      return transferNotes
    },
    filteredTransferNotes() {
      if (this.transferNotesType === 'sticky') {
        return this.$lodash().filter(this.transferNotes, function (note) {
          return note.sticky === true
        })
      } else {
        let self = this;
        return this.$lodash().filter(this.transferNotes, function (note) {
          return note.sticky === false && note.date === self.date
        })
      }
    },
  },
  data () {
    return {
      addNewTransferNote: false
    }
  },
  methods: {
    onClose () {
      this.$emit('onClose')
    },
    getTitleTransferNotes() {
      if (this.transferNotesType === 'sticky') {
        return 'Mededeling'
      } else {
        return 'Overdracht'
      }
    },
    onDialogAddShow () {
      this.addNewTransferNote = false
    },
    startNewTransferNote () {
      this.addNewTransferNote = true
    }
  }
}
</script>
